import { render, staticRenderFns } from "./SeriesSettings.vue?vue&type=template&id=0a035b56&"
import script from "./SeriesSettings.vue?vue&type=script&lang=ts&"
export * from "./SeriesSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports